import * as React from "react";
const CollectionIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#194557"
      d="M0 6.919A6.919 6.919 0 0 1 6.919 0H57.08A6.919 6.919 0 0 1 64 6.919V57.08A6.919 6.919 0 0 1 57.081 64H6.92A6.919 6.919 0 0 1 0 57.081V6.92Z"
    />
    <path
      fill="#fff"
      fillOpacity={0.9}
      d="M0 6.919A6.919 6.919 0 0 1 6.919 0H57.08A6.919 6.919 0 0 1 64 6.919V57.08A6.919 6.919 0 0 1 57.081 64H6.92A6.919 6.919 0 0 1 0 57.081V6.92Z"
    />
    <path
      fill="#194557"
      fillRule="evenodd"
      d="M38.667 19.5h-20V22h17.5v10h10.07l1.596 2.433V42h2.5v-8.334h-.012l-7.555-11.51h-4.1V19.5Zm5.929 10h-5.93V24.656h2.751l3.179 4.844Zm-29.263 3.333v-2.5H22v2.5h-6.667Zm9.167-7.5H13.667v2.5H24.5v-2.5Zm-6.25 15.834a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Zm5 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0ZM42 37.417a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Zm0 2.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM27.833 39.5h8.334V42h-8.334v-2.5Zm-11.666-3.333h-2.5V42h2.5v-5.833Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillOpacity={0.4}
      fillRule="evenodd"
      d="M38.667 19.5h-20V22h17.5v10h10.07l1.596 2.433V42h2.5v-8.334h-.012l-7.555-11.51h-4.1V19.5Zm5.929 10h-5.93V24.656h2.751l3.179 4.844Zm-29.263 3.333v-2.5H22v2.5h-6.667Zm9.167-7.5H13.667v2.5H24.5v-2.5Zm-6.25 15.834a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Zm5 0a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0ZM42 37.417a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Zm0 2.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM27.833 39.5h8.334V42h-8.334v-2.5Zm-11.666-3.333h-2.5V42h2.5v-5.833Z"
      clipRule="evenodd"
    />
  </svg>
);
export default CollectionIcon;
